import { DownloadOutlined } from '@ant-design/icons';
import { selectors } from 'app/services/projects';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Button, Dropdown } from 'antd';
import { TooltipButton } from 'components';
import { useTranslation } from 'react-i18next';
import { useScreenBreakpoint } from 'hooks';
import { ProjectReportType } from 'constants/project';
import { State } from 'constants/site';
import { User } from 'constants/user';

import { useHasAnyRole } from 'hooks/authorization/useHasRole';

type DownloadReportProps = {
  isExecuting?: (isFetching: boolean) => void,
  lastType: any,
  isFetching: any
  onClick: any,
  downloadReport: any,
}

const downloadReportButtons = ({ isExecuting, lastType, onClick, downloadReport, isFetching }: DownloadReportProps) => {
  const { t } = useTranslation();
  const project = useSelector(selectors.getProject);
  const { isMobile, isMedium, isExtraLarge } = useScreenBreakpoint();
  const hasAccess = useHasAnyRole([ User.Roles.ADMIN, User.Roles.CLIENT ]);

  useEffect(() => {
    if (isExecuting) isExecuting(isFetching);
  }, [ isFetching, isExecuting ]);

  if (!project) return [];

  if (project.State !== State.ACTIVE) {
    return (
      [
        <TooltipButton
          key='Download report'
          title={t('common.downloadreport')}
          buttonProps={{
            icon: <DownloadOutlined />,
            type: 'link',
            onClick: () => downloadReport({ projectId: project.Id }),
            loading: isFetching
          }}
        />
      ]
    );
  }

  const items = [
    {
      label: t('entities.project.reports.asbestos'),
      key: ProjectReportType.ASBESTOS,
      icon: <DownloadOutlined />,
      onClick: () => onClick(ProjectReportType.ASBESTOS)
    },
    {
      label: t('entities.project.reports.measurement'),
      key: ProjectReportType.MEASUREMENT,
      icon: <DownloadOutlined />,
      onClick: () => onClick(ProjectReportType.MEASUREMENT)

    },
    {
      label: t('entities.project.reports.negativepressure'),
      key: ProjectReportType.NEGATIVE_PRESSURE,
      icon: <DownloadOutlined />,
      onClick: () => onClick(ProjectReportType.NEGATIVE_PRESSURE)
    },
  ];

  if (!hasAccess) return [];

  if ((isMobile || (!isMedium || !isExtraLarge))) {
    return items.map(item => (<TooltipButton
      key={item.key}
      title={item.label}
      buttonProps={{
        icon: item.icon,
        type: 'link',
        onClick: item.onClick,
        loading: item.key === lastType && isFetching,
        disabled: item.key !== lastType && isFetching
      }}
    />));
  }

  return (
    [
      <Dropdown menu={{ items }} placement="bottom" key={'dropdownmenu'} disabled={isFetching}>
        <Button type='link' icon={<DownloadOutlined />} loading={isFetching}>
          {t('common.preview')}
        </Button>
      </Dropdown>
    ]
  );
};

export default downloadReportButtons;